import {calculatePercentageHelper} from "@/mega-ui/helpers/function/calculatePercentageHelper";

export const percentageHelper = (numerator: number, denominator: number): number => {
    const value = calculatePercentageHelper(numerator, denominator);
    return value > 100 ? 100 : value;
}